import { createContext } from "react";

import { noop } from "@/utils/function.utils";

import { SocialLoginProvider } from "./AuthContext.types";

export class LoginSocialError extends Error {
  public readonly type: "popupBlocked" | "invalidData";

  constructor(type: "popupBlocked" | "invalidData") {
    super(type === "popupBlocked" ? `Popup blocked` : "Invalid social login data");

    this.name = "LoginSocialError";
  }
}

export type AuthContextValueType = {
  isInitialized: boolean;
  isAuthenticated: boolean;
  accessToken: string | null;
  setAccessToken: (accessToken: string | null) => void;
  logout: (options?: { redirect?: boolean }) => Promise<void>;
  loginSocial: ({ provider }: { provider: SocialLoginProvider }) => Promise<void>;
  loginSocialLoading: boolean;
  loginSocialError: LoginSocialError | null;
};

export const AuthContext = createContext<AuthContextValueType>({
  isAuthenticated: false,
  isInitialized: false,
  accessToken: null,
  logout: () => Promise.resolve(),
  loginSocial: () => Promise.resolve(),
  loginSocialLoading: false,
  loginSocialError: null,
  setAccessToken: noop,
});
